import { ClassName, cn } from '../../utils';
import styles from './divider.module.css';

export function Divider({ className }: { className?: ClassName }) {
  return <hr className={cn(styles['divider'], className)} />;
}
